<div [ngClass]="getMainClass()" class="justify-align-center col flex-column" *ngIf="!isBlocked" (click)="navigateTo()">
	<div class="report-dashboard__item-photo image">
		<img [src]="iconDictionary[icon]" alt="photo" />
	</div>
	<span class="report-dashboard__item-text">{{ text }}</span>
</div>
